import './styles/simonsLayout.css';
import LoadLinkData from "./LoadLinkData";

export default function NavigateFriends() {
    return (<div id="navDelta" className="sidebox">
            <LoadLinkData formedName={"/data/frienddata.json"}/>
        </div>
    );
}
